module.exports = __webpack_public_path__ + "img/10_Inspirational Motivator.e55144da.svg";